import data from './generated/hsk.json';

export type PartOfSpeech = 'n' | 'v' | 'adj' | 'adv' | 'pron' | 'mw' | 'num' | 'conj' | 'prep' | 'part' | 'interj' | 'suffix' | 'prefix' | 'numMw' | 'onom';

/** A vocabulary item from the 2025 HSK syllabus (in force since July 2026). */
export interface Word {
  /** Characters and pinyin: unique, and stable across content updates. */
  readonly id: string;
  /** Characters (simplified). */
  readonly h: string;
  /** Pinyin with tone marks, as printed in the syllabus. */
  readonly p: string;
  /** Numbered pinyin, one syllable per character ("ba4 ba5"; erhua 儿 is "r5"). Drives the voice clips. */
  readonly pn: string;
  /** Short English gloss, written for this project. */
  readonly e: string;
  /** HSK level (1–9) in the 2025 syllabus. */
  readonly level: number;
  readonly pos: readonly PartOfSpeech[];
  /** Measure words for nouns (from CC-CEDICT). */
  readonly mw?: readonly string[];
  /** False for grammar words (particles, affixes), which are taught in sentences instead. */
  readonly quiz?: boolean;
}

/**
 * Generated by scripts/build-content.mjs from data/vendor (the syllabus) and data/content (our glosses).
 * Edit those, then run `npm run build:content`.
 */
export const WORDS: readonly Word[] = data as Word[];

/** Words that can be a bubble. */
export const QUIZ_WORDS: readonly Word[] = WORDS.filter(w => w.quiz !== false);

/** Levels shipped in the app so far. */
export const LEVELS: readonly number[] = [...new Set(WORDS.map(w => w.level))].sort((a, b) => a - b);

/** The parts of a gloss, used to keep near-synonyms from appearing against each other. */
export const glossParts = (e: string): string[] =>
  e.split(';').map(s => s.replace(/\(.*?\)/g, '').trim().toLowerCase()).filter(Boolean);

export function overlaps(a: Word, b: Word): boolean {
  const pa = glossParts(a.e);
  return glossParts(b.e).some(x => pa.includes(x));
}
